const moment = require('moment')

const state = function () {
    return {
      list: [],
      loading: false,
    }
}

export default {
    ...state()
}

export const initialState = state()
